<template>
    <Head title="Register" />
    <div class="min-h-screen flex">
        <div class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
            <div class="mx-auto w-full max-w-sm lg:w-96">
                <div>
                    <span class="font-bold text-gray-400 text-4xl flex justify-center lg:justify-start">
                        <logo class="h-12 w-auto inline"/>
                    </span>
                    <h2 class="mt-6 text-3xl font-thin text-gray-900">Hello! ^_^</h2>
                    <p class="mt-8 text-sm text-gray-600">
                        Welcome to Orion, Reethi Foto's very own studio management system. Please proceed to register by filling up the following form 😃
                    </p>
                </div>


                <div class="mt-6">
                    <form class="space-y-6" @submit.prevent="register">
                        <text-input class="flex-grow" v-model="form.name" :error="form.errors.name" name="name" label="Name" autofocus required="" placeholder="Jane Doe">
                            <UserIcon class="h-6 text-gray-500"/>
                        </text-input>
                        <text-input class="space-y-1" v-model="form.email" :error="form.errors.email" name="email" label="Email address" type="email" required="" placeholder="you@reethifoto.com">
                            <MailIcon class="h-6 text-gray-500"/>
                        </text-input>
                        <text-input class="space-y-1" v-model="form.password" :error="form.errors.password" name="password" label="Password" type="password" required="" autocomplete="current-password" placeholder="Please type in a secure password">
                            <KeyIcon class="h-6 text-gray-500"/>
                        </text-input>
                        <text-input class="space-y-1" v-model="form.phone_number" :error="form.errors.phone_number" name="phone_number" label="Phone Number" placeholder="You phone number (Not required)">
                            <DeviceMobileIcon class="h-6 text-gray-500"/>
                        </text-input>

                        <div class="flex items-center justify-between">
                            <div class="flex items-center">
                                <input id="remember-me" name="remember-me" type="checkbox" v-model="form.remember" class="h-4 w-4 text-reethi-purple focus:ring-reethi-purple accent-reethi-purple border-gray-300 rounded" />
                                <label for="remember-me" class="ml-2 block text-sm text-gray-900"> Remember me </label>
                            </div>

                            <div class="text-sm">
                                <a href="#" class="font-medium text-orange-500 hover:text-reethi-purple"> Forgot your password? </a>
                            </div>
                        </div>

                        <div class="flex flex-row">
                            <Link
                                as="a"
                                method="get"
                                :href="this.$route('login')"
                                class="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium border border-gray-300 bg-white hover:border-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Back to Login
                            </Link>
                            <span class="flex flex-grow"></span>
                            <loading-button :loading="form.processing" class="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-reethi-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" type="submit">Register</loading-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="hidden lg:block relative w-0 flex-1">
            <login-banner class="absolute inset-0 h-full w-full object-cover" />
        </div>
    </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import { Head } from '@inertiajs/inertia-vue3'
import { Link } from '@inertiajs/inertia-vue3'
import LoginBanner from '@/Pages/Auth/LoginBanner'
import LoadingButton from '@/Shared/LoadingButton'

import {
    KeyIcon,
    MailIcon,
    UserIcon,
    UsersIcon,
    DeviceMobileIcon
} from '@heroicons/vue/outline'

export default {
    components: {
        Head,
        Logo,
        Link,
        KeyIcon,
        MailIcon,
        UserIcon,
        UsersIcon,
        TextInput,
        LoginBanner,
        LoadingButton,
        DeviceMobileIcon
    },
    data() {
        return {
            form: this.$inertia.form({
                name: '',
                email: '',
                password: '',
                phone_number: '',
            }),
        }
    },
    methods: {
        register() {
            this.form.post(this.$route('register.store'))
        },
    },
}
</script>
